<div class="employee-details gradient-background p-4 rounded shadow">
    <h2 class="employee-name">{{ employee.name }} {{ employee.surname }}</h2>
    <p class="employee-description">{{ employee.employeeDescription }}</p>
  </div>